import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { extractDomain } from "../../utils/helpers";
import { baseQueryWithAuthCheck } from "../../utils/baseQueryWithAuthCheck";
import { endPoints, MIDDLEWARE_SLUG } from "../../apis/apiEndPoints";
import {
  ICampaignSenderDetails,
  ITemplate,
  ITemplatePlaceholders,
} from "../../types/campaign.types";

const DOMAIN = extractDomain();

export const campaignComposeApi = createApi({
  reducerPath: "campaignComposeApi",
  baseQuery: baseQueryWithAuthCheck(
    fetchBaseQuery({
      baseUrl: `${window.location.origin}${MIDDLEWARE_SLUG}/middleware`,
    })
  ),
  endpoints: (builder) => ({
    // to fetch templates - useGetWhatsAppTemplatesQuery
    getWhatsAppTemplates: builder.query<ITemplate[], {}>({
      query: () => ({
        url: `${endPoints.WHATS_APP_TEMPLATES}`,
        method: "GET",
        headers: {
          domain: DOMAIN,
        },
        withCredentials: true,
      }),
    }),

    // to fetch templates placeholders - useGetTemplatesPlaceholdersQuery
    // getTemplatesPlaceholders: builder.query<
    //   ITemplatePlaceholderValues,
    //   { initiationId: string; campaignId: string }
    // >({
    //   query: ({ initiationId, campaignId }) => ({
    //     url: `${endPoints.WHATS_APP_TEMPLATES_PLACEHOLDERS}?initiationId=${initiationId}&campaignId=${campaignId}`,
    //     method: "GET",
    //     headers: {
    //       domain: DOMAIN,
    //     },
    //     withCredentials: true,
    //   }),
    // }),

    // to fetch templates placeholders based on selected template - useGetTemplatesPlaceholdersMutation
    getTemplatesPlaceholders: builder.mutation<
    ITemplatePlaceholders,
      { initiationId: string; campaignId: string; templateId: string }
    >({
      query: ({ initiationId, campaignId, templateId }) => ({
        url: `${endPoints.WHATS_APP_TEMPLATES_PLACEHOLDERS}?initiationId=${initiationId}&campaignId=${campaignId}&templateId=${templateId}`,
        method: "GET",
        headers: {
          domain: DOMAIN,
        },
        withCredentials: true,
      }),
    }),

    // to fetch sender details - useGetCampaignSenderDetailsQuery
    getCampaignSenderDetails: builder.query<ICampaignSenderDetails, {}>({
      query: () => ({
        url: `${endPoints.SENDER_DETAILS}`,
        method: "GET",
        headers: {
          domain: DOMAIN,
        },
        withCredentials: true,
      }),
    }),

    // start campaign - usePostStartCampaignMutation
    postStartCampaign: builder.mutation<
      unknown,
      { payload: FormData; isMedia: boolean }
    >({
      query: ({ payload, isMedia }) => ({
        url: `${endPoints.START_CAMPAIGN}${isMedia ? "/startCampaign" : ""}`,
        method: "POST",
        headers: {
          domain: DOMAIN,
        },
        body: payload,
        withCredentials: true,
      }),
    }),
  }),
});

export const {
  useGetWhatsAppTemplatesQuery,
  usePostStartCampaignMutation,
  useGetCampaignSenderDetailsQuery,
  // useGetTemplatesPlaceholdersQuery,
  useGetTemplatesPlaceholdersMutation,
} = campaignComposeApi;
